import { LocalizedLink } from "@/components/LocalizedLink";
import { cn } from "@/lib/utils";

export type BreadcrumbItem = {
  label: string;
  href?: string;
};

type Props = {
  items: BreadcrumbItem[];
  className?: string;
  ariaLabel?: string;
};

const linkClass =
  "hover:text-foreground transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 rounded-sm";

export function Breadcrumb({ items, className, ariaLabel = "Breadcrumb" }: Props) {
  if (items.length === 0) return null;

  return (
    <nav aria-label={ariaLabel} className={cn("text-sm text-muted-foreground", className)}>
      <ol className="flex flex-wrap items-center gap-x-1.5 gap-y-1 list-none m-0 p-0">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={`${item.label}-${index}`} className="inline-flex items-center gap-1.5 min-w-0">
              {index > 0 ? (
                <span aria-hidden className="text-muted-foreground/60 select-none">
                  /
                </span>
              ) : null}

              {isLast || !item.href ? (
                <span
                  className="truncate text-foreground font-medium"
                  aria-current={isLast ? "page" : undefined}
                >
                  {item.label}
                </span>
              ) : (
                <LocalizedLink to={item.href} className={cn("truncate", linkClass)}>
                  {item.label}
                </LocalizedLink>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
